import { render, staticRenderFns } from "./RecommendationReasons.vue?vue&type=template&id=1e1432a8&scoped=true&"
import script from "./RecommendationReasons.vue?vue&type=script&lang=js&"
export * from "./RecommendationReasons.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationReasons.vue?vue&type=style&index=0&id=1e1432a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1432a8",
  null
  
)

export default component.exports